import '../index.global.scss';
import theme from './theme.scss';

export default {
  ...theme,
};
